define('TescoMobile_Customer/js/view/account/confirm-message-one-off-data',['uiComponent', 'jquery', 'ko', 'Magento_Ui/js/modal/modal', 'mage/translate'], function (Component, $, ko, modal, $t) {
  'use strict';

  return Component.extend({
    modalWindow: null,
    isLoading: ko.observable(true),
    messages: ko.observableArray(),
    selectedBundle: ko.observable(''),
    bundleAvailability: ko.observable(''),
    setModalElement: function (element) {
      var self = this;
      var options = {
        modalClass: 'confirmation-message-one-off-data-modal',
        responsive: true,
        innerScroll: true,
        type: 'popup',
        clickableOverlay: false,
        opened: function () {
          this._updateContent(element);
        }.bind(this)
      };
      this.modalWindow = element;
      modal(options, $(this.modalWindow));
      $(this.modalTrigger).on('click', function () {
        let selectedBundle = $('input[name="one_off_data"]:checked'),
          labelData,
          labelPrice;
        labelData = selectedBundle.data('label-data');
        labelPrice = selectedBundle.data('label-price');
        self.selectedBundle(labelData + ' - ' + labelPrice);
        self.bundleAvailability($t('Your bundle will end on your next bill date: %1.').replace('%1', self.nextBillDate));
        $(element).modal('openModal');
      }.bind(this));
    },
    _updateContent: function (element) {
      this.isLoading(false);
    },
    showLoader: function () {
      $("#confirmation-message-one-off-data button.confirm").click(function () {
        $(this).trigger('processStart');
      });
    },
    confirm: function () {
      $('#customer-account-one-off-data').submit();
    },
    cancel: function () {
      $(this.modalWindow).modal('closeModal');
    }
  });
});

